import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import PrivacyPolicy from './views/PrivacyPolicy.vue';
import LegalNotice from './views/LegalNotice.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about/privacy',
      name: 'privacyPolicy',
      component: PrivacyPolicy,
    },
    {
      path: '/about/legal',
      name: 'legalNotice',
      component: LegalNotice,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const loggedIn = localStorage.getItem('user');

  if (requiresAuth && !loggedIn) {
    next('/login');
  } else if (requiresAuth && loggedIn) {
    next();
  } else {
    next();
  }
});

export default router;
